import { NgModule } from '@angular/core';
import { AuctionIconPipe } from './auctionIcon.pipe';
import { CamelCaseToDashPipe } from './camelCaseToDash.pipe';
import { DayPipe } from './day.pipe';
import { EtaPipe } from './eta.pipe';
import { FilterPipe } from './filter.pipe';
import { GetByIdPipe } from './getById.pipe';
import { HtmlToPlaintextPipe } from './htmlToPlaintext.pipe';

import { KeysPipe } from './keys.pipe';

@NgModule({
  declarations: [
    KeysPipe,
    GetByIdPipe,
    HtmlToPlaintextPipe,
    FilterPipe,
    CamelCaseToDashPipe,
    AuctionIconPipe,
    DayPipe,
    EtaPipe,
  ],
  exports: [
    KeysPipe,
    GetByIdPipe,
    HtmlToPlaintextPipe,
    FilterPipe,
    CamelCaseToDashPipe,
    AuctionIconPipe,
    DayPipe,
    EtaPipe,
  ],
})
export class FusePipesModule {
}
